import React from 'react';
import { getSpacing } from '@this/src/components/shared/ui/theme';
import type Trip from '@this/domain/trip/trip2';

interface Props {
  trip: Trip;
}

export const HotelPriceRegulationInfo: React.FC<Props> = ({ trip }) => {
  return (
    <>
      <h3 style={{ marginBottom: `${getSpacing(1)}px` }}>旅費規程適用商品情報</h3>
      {trip.currentOrder?.orderItems &&
        trip.currentOrder.orderItems.map((item, i) => {
          const firstHotel = item.hotels && item.hotels.length > 0 ? item.hotels[0] : null;
          return (
            firstHotel && (
              <React.Fragment key={`${i + 1}`}>
                <p>□ 商品情報{`${i + 1} (${firstHotel.name})`}</p>
                <br />
                <ul>
                  {item.hotelPricePrefecture && (
                    <>
                      <li>規程エリア(地域) {item.hotelPricePrefecture.regionName}</li>
                      <li>規程エリア(県) {item.hotelPricePrefecture.name}</li>
                    </>
                  )}
                  {item.hotelPriceMunicipality && <li>規程エリア(市区町村) {item.hotelPriceMunicipality.name}</li>}
                  <li>宿泊規程金額 {item.hotelPriceLimit}円</li>
                </ul>
                <br />
              </React.Fragment>
            )
          );
        })}
    </>
  );
};
